require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-role-of-emotion-in-automotive-purchasing.json") })
        }
      }, "path---news-the-role-of-emotion-in-automotive-purchasing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-role-of-emotion-in-automotive-purchasing!./.cache/json/news-the-role-of-emotion-in-automotive-purchasing.json
// module id = 1439
// module chunks = 231608221292675